<template>
  <div>
    <template>
      <!-- 按量统一计价 -->
      <a-row v-if="form.price_type === 'amount'" class="d-flex">
        <a-form-model-item style="flex-shrink:0">
          <div class="text-append no-right-border">{{$t('bill.rate.each')}}</div>
        </a-form-model-item>
        <a-form-model-item prop="price_step" style="flex: 1 1 auto">
          <a-input-number v-model="form.price_step" :min="1" :step="1" style="width:100%" :placeholder="$t('bill.rate.title.price_unit')" />
        </a-form-model-item>
        <a-form-model-item style="flex-shrink:0">
          <a-select v-if="unitOptions.length > 0" v-model="form.price_unit" style="width: 100px">
            <a-select-option v-for="item in unitOptions" :key="item" :value="item">{{item}}</a-select-option>
          </a-select>
          <div v-else class="text-append no-left-border">{{priceUnit}}</div>
        </a-form-model-item>
        <a-form-model-item class="ml-3">
          <a-select v-model="form.currency" style="width: 70px" :dropdownMatchSelectWidth="false">
            <a-select-option v-for="item in currencyOptions" :key="item.key" :value="item.key">
              <span class="oc-selected-display-none">{{ item.label }} </span>{{ item.key }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item prop="rate" style="flex: 0 0 150px">
          <a-input-number v-model="form.rate" :min="0" :step="0.01" :precision="6" :placeholder="$t('bill.rate.title.rate')" style="width:100%" />
        </a-form-model-item>
        <a-form-model-item class="ml-3" style="flex: 0 0 100px" v-if="form.precision !== 'usage'">
          <a-select v-model="form.cycle" prop="cycle">
            <a-select-option :disabled="['month', 'year'].includes(form.precision)" value="day"> / {{$t('bill.budget_period_type_day')}}</a-select-option>
            <a-select-option value="month"> / {{$t('bill.budget_period_type_month')}}</a-select-option>
            <a-select-option value="year"> / {{$t('bill.budget_period_type_year')}}</a-select-option>
          </a-select>
        </a-form-model-item>
      </a-row>
      <!-- 按量阶梯计价 -->
      <template v-if="form.price_type === 'amount_range'">
        <a-row v-for="(item,index) in form.range_list" :key="index" class="d-flex">
          <a-form-model-item style="flex-shrink:0">
            <div class="text-append no-right-border">{{$t('bill.rate.gt')}}</div>
          </a-form-model-item>
          <a-form-model-item :prop="`range_list.${index}.line`" :rules="rules.item_line" style="flex: 1 1 auto">
            <a-input-number v-if="index !== 0" v-model="item.line" :min="0" :step="1" style="width:100%;" />
            <a-input-number v-else :value="0" style="width:100%;" disabled />
          </a-form-model-item>
          <a-form-model-item>
            <div class="text-append no-right-border no-left-border">{{$t('bill.rate.each')}}</div>
          </a-form-model-item>
          <a-form-model-item prop="price_step" style="flex: 1 1 auto">
            <a-input-number v-model="form.price_step" :min="0" :step="1" style="width:100%;" />
          </a-form-model-item>
          <a-form-model-item style="flex-shrink:0">
            <a-select v-if="unitOptions.length" v-model="form.price_unit" style="width: 100px">
              <a-select-option v-for="item in unitOptions" :key="item" :value="item">{{item}}</a-select-option>
            </a-select>
            <div v-else class="text-append no-left-border">{{priceUnit}}</div>
          </a-form-model-item>
          <a-form-model-item class="ml-3">
            <a-select v-model="form.currency" style="width: 70px" :dropdownMatchSelectWidth="false">
              <a-select-option v-for="item in currencyOptions" :key="item.key" :value="item.key">
                <span class="oc-selected-display-none">{{ item.label }} </span>{{ item.key }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item :prop="`range_list.${index}.rate`" :rules="rules.item_rate" style="flex: 0 0 100px">
            <a-input-number v-model="item.rate" :min="0" :step="0.01" :precision="6" style="width:100%" />
          </a-form-model-item>
          <a-form-model-item class="ml-3" style="flex: 0 0 80px">
            <a-select v-model="form.cycle" prop="cycle" style="border-left:none" v-if="form.precision !== 'usage'">
              <a-select-option :disabled="['month', 'year'].includes(form.precision)" value="day"> / {{$t('bill.budget_period_type_day')}}</a-select-option>
              <a-select-option value="month"> / {{$t('bill.budget_period_type_month')}}</a-select-option>
              <a-select-option value="year"> / {{$t('bill.budget_period_type_year')}}</a-select-option>
            </a-select>
          </a-form-model-item>
          <span v-if="form.range_list.length > 1" class="ml-3" style="flex: 0 0 20px;text-align:center">
            <a-button shape="circle" icon="minus" size="small" @click="deleteStep(index)" />
          </span>
        </a-row>
      </template>
      <!-- 分阶梯一口价 -->
      <template v-if="form.price_type === 'fixed_range'">
        <a-row v-for="(item,index) in form.range_list" :key="index" class="d-flex">
          <a-form-model-item style="flex-shrink:0">
            <div class="text-append no-right-border">{{$t('bill.rate.gt')}}</div>
          </a-form-model-item>
          <a-form-model-item :prop="`range_list.${index}.line`" :rules="rules.item_line" style="flex: 1 1 auto">
            <a-input-number v-if="index !== 0" v-model="item.line" :min="0" :step="1" style="width:100%;" />
            <a-input-number v-else :value="0" style="width:100%;" disabled />
          </a-form-model-item>
          <a-form-model-item style="flex-shrink:0">
            <a-select v-if="unitOptions.length" v-model="form.price_unit" style="width: 100px">
              <a-select-option v-for="item in unitOptions" :key="item" :value="item">{{item}}</a-select-option>
            </a-select>
            <div v-else class="text-append no-left-border">{{priceUnit}}</div>
          </a-form-model-item>
          <a-form-model-item class="ml-3">
            <a-select v-model="form.currency" style="width: 70px" :dropdownMatchSelectWidth="false">
              <a-select-option v-for="item in currencyOptions" :key="item.key" :value="item.key">
                <span class="oc-selected-display-none">{{ item.label }} </span>{{ item.key }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item :prop="`range_list.${index}.rate`" :rules="rules.item_rate" style="flex: 0 0 100px">
            <a-input-number v-model="item.rate" :min="0" :step="0.01" :precision="6" style="width:100%" />
          </a-form-model-item>
          <a-form-model-item class="ml-3" style="flex: 0 0 80px" v-if="form.precision !== 'usage'">
            <a-select v-model="form.cycle" prop="cycle" style="border-left:none">
              <a-select-option :disabled="['month', 'year'].includes(form.precision)" value="day"> / {{$t('bill.budget_period_type_day')}}</a-select-option>
              <a-select-option value="month"> / {{$t('bill.budget_period_type_month')}}</a-select-option>
              <a-select-option value="year"> / {{$t('bill.budget_period_type_year')}}</a-select-option>
            </a-select>
          </a-form-model-item>
          <span v-if="form.range_list.length > 1" class="ml-3" style="flex: 0 0 20px;text-align:center">
            <a-button shape="circle" icon="minus" size="small" @click="deleteStep(index)" />
          </span>
        </a-row>
      </template>
      <a-button v-if="form.price_type !== 'amount'" type="link" @click="addStep"><a-icon type="plus" style="padding: 0" /> {{$t('bill.rate.add_billing_rules')}}</a-button>
    </template>
  </div>
</template>

<script>
import { CURRENCY_LIST } from '@/constants/currency'
export default {
  name: 'PriceStepRate',
  props: {
    form: Object,
    rules: Object,
  },
  data () {
    return {
      currencyOptions: CURRENCY_LIST,
    }
  },
  computed: {
    unitOptions () {
      const { usage_type } = this.form
      if (usage_type === 'capacity' || usage_type === 'volume' || usage_type === 'bytes' || usage_type === 'traffic' || usage_type === 'traffic_tx' || usage_type === 'traffic_rx') {
        return ['B', 'Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB']
      } else if (usage_type === 'bandwidth') {
        return ['bps', 'Kbps', 'Mbps', 'Gbps', 'Tbps', 'Pbps', 'Ebps', 'Bps', 'KBps', 'MBps', 'GBps', 'TBps', 'PBps', 'EBps']
      }
      return []
    },
    priceUnit () {
      const { usage_type, price_unit } = this.form
      console.log('usage_type', usage_type, 'price_unit', price_unit)
      if (usage_type === 'requests') {
        return this.$t('rate.price_unit.requests')
      }
      if (usage_type === 'cpu' && price_unit === 'instance') {
        return this.$t('rate.price_unit.cpu_instance')
      }
      return price_unit === 'instance' ? this.$t('rate.price_unit.general_instance') : price_unit
    },
  },
  methods: {
    addStep () {
      this.form.range_list.push({ ...this.form.range_list[this.form.range_list.length - 1] })
    },
    deleteStep (index) {
      this.form.range_list = this.form.range_list.filter((item, idx) => index !== idx)
    },
  },
}
</script>

<style lang="less" scoped>
.text-append{
  height: 32px;
  padding: 0 10px;
  border: 1px solid #d9d9d9;
  line-height: 32px;
  box-sizing: border-box;
  margin: 4px 0;
}
.no-right-border {
  border-right: none;
}
.no-left-border {
  border-left: none;
}
</style>
